import { createContext } from 'react';

import { Theme } from '@/shared/config';

interface ThemeContextType {
  changeTheme: (theme: Theme) => void;
  theme: Theme;
}

export const ThemeContext = createContext<ThemeContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  changeTheme: () => {},
  theme: Theme.Light,
});
